module.exports = __webpack_public_path__ + "static/media/Capital And Financial Management Report Summary.41c3a229.pdf";